// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qrCode_container[data-v-781f4550]{text-align:center}.qrCode_container .title[data-v-781f4550]{font-size:20px;font-weight:700}.qrCode_container .qrCode[data-v-781f4550]{margin:20px 0;width:30%}.qrCode_container .sign_num[data-v-781f4550]{margin-bottom:20px;font-size:16px}.qrCode_container .sign_num .num[data-v-781f4550]{color:#449cef}.qrCode_container .info[data-v-781f4550]{font-size:20px}", ""]);
// Exports
module.exports = exports;
